<template>
  <div class="box10">
    <pageTitle
      title="学员活动" 
      text="项目将定期举办各类线上线下学员活动，以满足在读学员<br/>行业信息交流、资源共享或人脉圈层搭建拓展的需求" />
    <div class="subject-box">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="box">
            <div class="title">{{ item.title }}</div>
            <div class="text">{{ item.text }}</div>
            <img :src="item.pic" alt="" />
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <pageTitle title="学员掠影" />
    <div class="subject-box">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems-two">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in studentList"
          :key="index"
        >
          <div class="box">
            <div class="top-box">
              <img src="../../../assets/coursePage/illinois/box10/icon.png" alt="" />
              <div class="name">{{ item.name }}</div>
            </div>
            <div class="title two-title">{{ item.title }}</div>
            <div v-if="item.title2" class="title two-title">{{ item.title2 }}</div>
            <div class="text two-text">{{ item.text }}</div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: 'auto',
        spaceBetween: 12,
        centeredSlides: true,
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false /* 触摸滑动后是否继续轮播 */,
        //   disableOnInteraction: false,
        // },
      },
      list:  [
         {
          title: "深圳",
          text: "邀请行业大咖现场讲座，深入探讨本土商业案例，强化课程内容的实际应用",
          pic: require("../../../assets/coursePage/illinois/box10/pic1.png"), 
        },
        {
          title: "北京",
          text: "同窗同学线下座谈，分享学习心得，共享优质资源，享受与优秀学员思想同频共振的乐趣",
          pic: require("../../../assets/coursePage/illinois/box10/pic2.png"), 
        },
        {
          title: "上海",
          text: "汇聚 MBA 同校校友，交流所在行业动态，帮助同学们拓宽视野，获取最新信息",
          pic: require("../../../assets/coursePage/illinois/box10/pic3.png"), 
        },
      ],
      studentList: [
        {
          name: "董晴",
          title: "吉林大学本科，法国硕士学位",
          title2: "创业者，私募基金经理",
          text: "我还是更喜欢体系化的学习，当我对一个领域感兴趣时，能够展示给我一个清晰路径，向前走的每一步，都是正确的、扎实的。IIT MBA 的学习给了我全新的收获，每门课程都非常值得用心对待，值得花心思静下来认真读。很多人会犹豫，职场人能不能工作的同时读一个美国高校的硕士?真的没有想象的那样难实现，我希望自己的故事能给更多人挑战自己的勇气。",
        }, 
        {
          name: "傅珊",
          title: "电子科技大学本科，曾任华为工程师",
          title2: "多年外企工作经验",
          text: "读MBA是一种很好的打开视野的方式，管理学的课程设置打破了单一的职业框架。这个项目给人的变化是潜移默化的，让我多年来的职业经验都有了一套系统和理论来对应。从企业的宏观战略开始，到人员管理，再到财务管理等细枝末节的部分，可谓是先看庐山真面目，继而走进此山中。",
        }, 
        {
          name: "朱明德",
          title: "上海交通大学本科，多年团队管理经验，一名持续创业者，目前是多家公司的股东和决策人",
          title2: "",
          text: "创业的几年来，我每天都要接触很多新领域的知识，大到公司战略，小到定价逻辑。如果缺乏管理学背景，只能通过不断试错来总结和成长；而在学习IIT-MBA 以后，我发现自己能够系统性地补足一直以来欠缺的能力板块，学会一样东西后，曾经的或者未来的事情可能会处理更好，我觉得很有意思。",
        }, 
      ]
    };
  },

  methods: {},
};
</script>

<style  lang="less" scoped>
.box10 {
  padding: 80px 0;
  background: #F4F4FB;
  width: 100%;
  font-family: PingFangSC, PingFang SC;
  /deep/.course-title-box{
    .course-title {
      font-weight: 600;
      font-size: 44px;
      color: #272020;
      line-height: 64px;
    }
    .course-text {
      margin-top: 24px;
      font-size: 26px;
      color: #272020;
      line-height: 40px;
    }
  } 
  .subject-box {
    box-sizing: border-box;
    position: relative;
    margin: 48px auto 80px;
    overflow: hidden;
    // .swiper-container{
    //   padding: 38px 0 0;
    // }
    .swiper-slide {
      width: 622px;
      background: #FFFFFF;
      border-radius: 24px;
      padding: 32px;
      box-sizing: border-box;
      text-align: center;
      .title {
        margin-top: 16px;
        font-weight: 600;
        font-size: 40px;
        color: #272020;
        line-height: 56px;
      }
      .text {
        margin-top: 16px;
        font-weight: 400;
        font-size: 26px;
        color: #272020;
        line-height: 40px;
      }
      img {
        margin-top: 32px;
        width: 558px;
        height: 340px;
      }
      .top-box {
        padding: 6px 0 48px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
          margin: 0 0 0 6px;
          width: 106px;
          height: 84px;
        }
        .name {
          margin-right: 12px;
          font-weight: bold;
          font-size: 40px;
          color: #D83F3F;
          line-height: 56px;
        }
      }
      .two-title {
        margin-top: 0;
        font-size: 30px;
        line-height: 44px;
        text-align: left;
      }
      .two-text {
        line-height: 44px;
        text-align: left;
      }
    }
  }
  .subject-box:last-child {
    margin-bottom: 0;
    .swiper-slide {
      height: 664px;
      box-sizing: border-box;
    }
  }
}
</style>
